/** DOM / scroll-spy id for a workflow's top-level settings section. */
export const makeWorkflowSectionId = (workflowType: string): string =>
  `__wf:${workflowType}`;

export const WORKFLOW_DOCUMENT_CATEGORY_SECTION = "document-upload-category";
export const WORKFLOW_DOWNLOAD_EMPTY_PACKET_SECTION = "download-empty-packet";

/** DOM / scroll-spy id for a template block inside a workflow section. */
export const makeWorkflowBlockSectionId = (
  workflowType: string,
  blockId: string,
): string => `__wf:${workflowType}:${blockId}`;

/** DOM / scroll-spy id for the PCC document upload category card. */
export const makeWorkflowDocumentCategorySectionId = (
  workflowType: string,
): string =>
  `__wf:${workflowType}:${WORKFLOW_DOCUMENT_CATEGORY_SECTION}`;

/** DOM / scroll-spy id for the per-workflow blank packet download card. */
export const makeWorkflowDownloadEmptyPacketSectionId = (
  workflowType: string,
): string => `__wf:${workflowType}:${WORKFLOW_DOWNLOAD_EMPTY_PACKET_SECTION}`;

export const isWorkflowSectionId = (id: string): boolean =>
  id.startsWith("__wf:");

/** Returns the workflow type for any workflow section or sub-section id. */
export const parseWorkflowSectionId = (id: string): string | null => {
  if (!isWorkflowSectionId(id)) {
    return null;
  }

  const payload = id.slice("__wf:".length);
  if (!payload) {
    return null;
  }

  const colonIndex = payload.indexOf(":");
  return colonIndex === -1 ? payload : payload.slice(0, colonIndex);
};
